module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero is-medium article-header",
    style: ({
      backgroundColor: _vm.thisproject.bgcolor
    })
  }, [_c('img', {
    staticClass: "article-header-img-desktop",
    attrs: {
      "src": '../../static/img/site/' + _vm.thisproject.poster + '.jpg'
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "article-inner"
  }, [_c('article-username', {
    attrs: {
      "project": _vm.thisproject
    }
  }), _vm._v(" "), _c('article-view', {
    attrs: {
      "project": _vm.thisproject
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c304ad3!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/containers/SingleArticle.vue
// module id = 33
// module chunks = 1